export function pageCountUtil(array, countPage) {
  return Array.from({length: Math.ceil(array.length / countPage)}, (_, i) => i + 1);
}
